/**
 * Upsell slider — global, idempotent, survives DOM swaps (cart drawer reload).
 *
 * - Initializes every [data-upsell] block found in the DOM.
 * - Watches for new blocks being inserted (e.g. cart drawer innerHTML replace)
 *   and initializes them automatically.
 * - Idempotent via data-upsell-initialized flag.
 * - ATC is a regular <form action="/cart/add"> — handled by the existing
 *   global submit listener in common.js (no duplicate cart logic here).
 */
(function () {
  var INIT_FLAG = 'data-upsell-initialized';

  function initOne(root) {
    if (!root || root.getAttribute(INIT_FLAG) === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var slider = root.querySelector('.upsell__slider');
    if (!slider) return;

    root.setAttribute(INIT_FLAG, 'true');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: false,
      watchOverflow: true,
      navigation: {
        prevEl: root.querySelector('.upsell__arrow--prev'),
        nextEl: root.querySelector('.upsell__arrow--next'),
      },
      pagination: {
        el: root.querySelector('.upsell__pagination'),
        clickable: true,
      },
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-upsell]');
    nodes.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Auto-init upsells inserted dynamically (e.g. cart drawer reload)
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-upsell]')) initOne(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-upsell]').forEach(initOne);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Expose manual hook for code that wants to re-init explicitly
  window.UpsellSlider = { init: initAll };
})();
